import { SxProps } from '@mui/material';

export const QuestionBankStyles = {
  header: {
    marginBottom: '24px',
    fontWeight: 'bold',
    fontSize: '1.8rem',
    textAlign: 'left',
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '16px',
  },
  questionContainer: {
    marginBottom: '24px',
    padding: '16px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
  chip: {
    marginBottom: '8px',
  },
  chipsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    marginBottom: '8px',
  },
  promptContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  prompt: {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 4,
    WebkitBoxOrient: 'vertical',
    textOverflow: 'ellipsis',
    wordWrap: 'break-word',
    lineHeight: '1.5rem',
    fontSize: '1rem',
    maxHeight: '6.8rem',
    marginRight: '8px',
    flex: 1,
  },
} satisfies Record<string, SxProps>;
